//hooks
import { useState } from "react";
import { useApi } from "../hooks/useApi";

//api
import { PostContact } from "../api/contact/PostContact";

//translate
import i18n from '../translate/i18n';
import { useTranslation } from 'react-i18next';

import CircularProgress from '@mui/material/CircularProgress';


const SignUp = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        client_name: '',
        client_phone: '',
        client_email: '',
        subject: '',
        message: '',
    });
    const [errorsData, setErrorsdata] = useState({
        client_name: false,
        client_phone: false,
        client_email: false,
        subject: false,
        message: false,
    });
  const {
    loading: contactLoading,
    error: homeTestimonialError,
    HandlerApi: contactApi
  } = useApi(PostContact, "POST");
    const handleChange = (e:any) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrorsdata(prev => ({ ...prev, [name]: false }));
    };
    const handleSubmit = async (e:any) => {
        e.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
        const newErrors = {
        client_name: formData.client_name.trim() === '',
        client_phone: formData.client_phone.trim() === '',
        client_email: formData.client_email.trim() === '' || !emailRegex.test(formData.client_email.trim()),
        subject: formData.subject.trim() === '',
        message: formData.message.trim() === '',
        };
        setErrorsdata(newErrors);
        console.log(errorsData);
        if(Object.values(newErrors).some(val => val)) return;
        const result = await contactApi(formData);
        if(result.success) {
            setFormData({
                client_name: '',
                client_phone: '',
                client_email: '',
                subject: '',
                message: '',
            });
            setErrorsdata({
                client_name: false,
                client_phone: false,
                client_email: false,
                subject: false,
                message: false,
            })
        }
    }
    return (
        <div className={`
        flex flex-col items-center 
        px-6 py-8 lg:py-0 
        w-1/2 
        rounded-[10px] 
        max-lg:w-full max-lg:mb-5
        bg-[#EDEBDF]
        ${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-bold"}
        `}
        >
            <div className="w-full rounded-lg md:mt-0 xl:p-0">
                <div className="p-6 max-sm:p-2 space-y-4 md:space-y-6 sm:p-8">
                    <h1 className="md:text-2xl">
                        {t("contact_text1")}
                    </h1>
                    <h4 className="md:text-md text-[#454D58] !mt-3">
                        {t("contact_text2")}
                    </h4>
                    <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
                        <div className="flex gap-3 max-sm:block">
                            <div className="w-1/2 max-sm:w-full max-sm:mb-5">
                                <p className="text-sm mb-2">{t("full_name")}</p>
                                <input 
                                type="text" 
                                name="client_name"
                                className={`bg-gray-50 border border-gray-300 ${errorsData.client_name ? "border-red-500" : ""} text-gray-900 text-sm rounded-lg block w-full p-2.5`}
                                value={formData.client_name}
                                onChange={handleChange}
                                />
                                <p className="text-red-500">{errorsData.client_name ? t("full_name_is_required") : ""}</p>
                            </div>
                            <div className="w-1/2 max-sm:w-full">
                                <p className="text-sm mb-2 ">{t("phone")}</p>
                                <input 
                                type="number"
                                name="client_phone"
                                className={`bg-gray-50 border border-gray-300 ${errorsData.client_phone ? "border-red-500" : ""} text-gray-900 text-sm rounded-lg block w-full p-2.5`}
                                value={formData.client_phone}
                                onChange={handleChange}
                                />
                                <p className="text-red-500">{errorsData.client_phone ? t("phone_is_required") : ""}</p>
                            </div>
                        </div>
                        <div className="flex gap-3 max-sm:block">
                            <div className='w-1/2 max-sm:w-full max-sm:mb-5'>
                                <p className="mb-2">{t("email")}</p>
                                <input 
                                type="email" 
                                placeholder="example@domain.com" 
                                name="client_email"
                                className={`bg-gray-50 border border-gray-300 ${errorsData.client_email ? "border-red-500" : ""} text-gray-900 text-sm rounded-lg block w-full p-2.5`}
                                value={formData.client_email}
                                onChange={handleChange}
                                />
                                <p className="text-red-500">{errorsData.client_email ? t("email_is_required") : ""}</p>
                            </div>
                            <div className="w-1/2 max-sm:w-full">
                                <p className="mb-2">{t("subject")}</p>
                                <input 
                                type="text" 
                                name="subject"
                                className={`bg-gray-50 border border-gray-300 ${errorsData.subject ? "border-red-500" : ""} text-gray-900 text-sm rounded-lg block w-full p-2.5`}
                                value={formData.subject}
                                onChange={handleChange}
                                />
                                <p className="text-red-500">{errorsData.subject ? t("subject_is_required") : ""}</p>
                            </div>
                        </div>
                        <div>
                            <p className="mb-2">{t("message")}</p>
                            <textarea 
                            name="message"
                            className={`bg-gray-50 border border-gray-300 ${errorsData.message ? "border-red-500" : ""} text-gray-900 text-sm rounded-lg block w-full p-2.5`}
                            value={formData.message}
                            onChange={handleChange}
                            />
                            <p className="text-red-500">{errorsData.message ? t("message_is_required") : ""}</p>
                        </div>
                        <button type="submit" className="w-full p-1 rounded-lg bg-secondaryColor text-primaryColor">
                            {contactLoading ? <CircularProgress/> : t("send_message")}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default SignUp
